import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = [ "trigger" ]

  toggle(e, standalone = true) {
    const trigger = e.currentTarget
    const target = document.getElementById( trigger.getAttribute("aria-controls") )
    const state = trigger.getAttribute("aria-expanded") !== "false"

    // Close other navigation if open
    if (standalone) {
      this.triggerTargets.forEach(element => {
        if (element.getAttribute("aria-expanded") === "true") {
          element.click()
        }
      })
    }

    trigger.setAttribute("aria-expanded", !state)
    target.setAttribute("aria-hidden", state)
  }

  toggleSubmenu(e) {
    this.toggle(e, false)
  }
}
